import React from "react";

/**
 * Logo ufficiale Metodo di Mare — scudo MR + onda dorata.
 *
 * Usa un asset PNG pre-ritagliato (public/logo-mr-shield.png) generato
 * dall'immagine brand ufficiale. Il container è quadrato con sfondo
 * navy allineato al colore --primary della landing (hsl(215 60% 11%)),
 * così il logo si integra visivamente con il resto del sito.
 *
 * Props:
 *   size    → lato in pixel (default 64)
 *   bg      → colore sfondo container. Default = --primary del brand.
 *             Passa "transparent" per rimuoverlo (utile su hero scuri).
 *   rounded → angoli arrotondati (default true)
 */
const LOGO_SRC = "/logo-mr-shield.png";

export default function LogoMR({
  size = 64,
  bg = "hsl(215, 60%, 11%)",
  rounded = true,
  className = "",
  ...rest
}) {
  return (
    <div
      role="img"
      aria-label="Logo Metodo di Mare"
      data-testid="logo-mr"
      className={className}
      style={{
        width: size,
        height: size,
        backgroundColor: bg === "transparent" ? "transparent" : bg,
        borderRadius: rounded ? Math.max(6, size * 0.14) : 0,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        overflow: "hidden",
        padding: Math.max(2, size * 0.06),
        boxSizing: "border-box",
      }}
      {...rest}
    >
      <img
        src={LOGO_SRC}
        alt=""
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          display: "block",
        }}
        draggable={false}
      />
    </div>
  );
}
